import { request, GETApi, POSTApi } from '../utils/request'
export const customReducer = request({
  reducerPath: 'customer', endpoints: (builder) => {
    return {
      login: POSTApi(builder, '/users/login'),//登录
      register: POSTApi(builder, '/users/register'),//注册
      verification: GETApi(builder, '/users/register/verification'),//校验验证码
      resetPwd: POSTApi(builder, '/users/resetPasswd'),//重置密码
      sendVerificationCode: GETApi(builder, '/users/sendVerificationCode'),//注册获取验证码,
      logout: GETApi(builder, '/users/logout'),//退出登录
      updateInfo: POSTApi(builder, '/users/update'),//修改账户信息
      updateEmail: POSTApi(builder, '/users/updateEmail'),//修改邮箱
      updatePwd: POSTApi(builder, '/users/updatePasswd'),//修改密码
      changeAcademic: GETApi(builder, '/users/changeAcademic'),//申诉为学术用户
      userInfo: GETApi(builder, '/users'),//查询用户信息
      userInfoByEmail: GETApi(builder, '/users/info'),//根据邮箱查询用户信息
      checkPwd:POSTApi(builder, '/users/checkPwd'),//检查旧密码是否正确
      wlsUseInfo: GETApi(builder, '/users/wlsUseInfo'),//查询当前用户WebLicense使用情况
    }
  }
})
export const {
  useLoginMutation,
  useRegisterMutation,
  useLazyVerificationQuery,
  useResetPwdMutation,
  useLazySendVerificationCodeQuery,
  useLazyLogoutQuery,
  useUpdateInfoMutation,
  useUpdateEmailMutation,
  useUpdatePwdMutation,
  useLazyChangeAcademicQuery,
  useLazyUserInfoQuery,
  useLazyUserInfoByEmailQuery,
  useCheckPwdMutation,
  useLazyWlsUseInfoQuery,
} = customReducer